export const counterList = [{
    value: 100,
    description: "Projets "

},
{
    value: 100,
    description: "clients"
    
},
{
    value: 10,
    description: "Experts "

},

]